import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ZINDEX_HIGH_1 } from 'utils/constants/app/ui';
import { Modal, ModalButtons } from 'components/Modal';
import { Button } from 'newcomponents/UI/Button';

const NOTICE_MODAL_WIDTH = 420;

interface IMultiviewGamesSameGameNoticeProps {
  open: boolean;
  setOpen: (arg: boolean) => void;
}

export const MultiviewGamesSameGameNotice: FC<
  IMultiviewGamesSameGameNoticeProps
> = ({ open, setOpen }) => {
  const { t } = useTranslation();

  const closeNoticeModal = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <Modal
      visible={open}
      maskClosable={false}
      title={t('casino.openSameGameNoticeTitle')}
      align="center"
      image={{
        lib: 'generic',
        name: 'info',
        theme: 'colored'
      }}
      width={NOTICE_MODAL_WIDTH}
      centered
      renderInBody
      onCancel={closeNoticeModal}
      closable={false}
      zIndex={ZINDEX_HIGH_1}
      preventScrollDisable
    >
      <span style={{ color: 'var(--v3-text-color)' }}>
        {t('casino.openSameGameNoticeDescription')}
      </span>
      <ModalButtons>
        <Button block type="primary" size="large" onClick={closeNoticeModal}>
          {t('casino.openSameGameNoticeConfirmActionText')}
        </Button>
      </ModalButtons>
    </Modal>
  );
};
